export default __webpack_public_path__ + "static/assets/med_pill_rectangle_flat_L0_solid_x_01_f.d88a90c0.png";